import { Component, OnInit } from '@angular/core';
import { DataStorageService } from '../../shared/data-storage.service';
import { BillerDashboardService } from './biller-dashboard.service';
import { Router } from '@angular/router';

import { NGXLogger } from 'ngx-logger';
import { ViewBillerDashboard, ViewBillerTransactionGraphs, BillerTransactions, BillerTransactionReport, RecentTxsnMain, KeyPerformanceOutput, InputBillerTxsnReport, TransactionAmountOutput } from './view-biller-Graphs';
import { DatePipe } from '@angular/common';
import { LeftMenu } from '../../shared/leftmenu/LeftMenu';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { User } from '../../shared/auth/user';
import {DashboardService} from '../dashboard.service';


export const transactionColor = 'rgb(252,123,161)';

export const transactionAmountColor = 'rgb(149,168,255)';

@Component({
  selector: 'app-biller-dashboard',
  templateUrl: './biller-dashboard.component.html',
  styleUrls: ['./biller-dashboard.component.css']
})

export class BillerDashboardComponent implements OnInit {
  user: User;
  billerId: string;
  viewBillerDashboard: ViewBillerDashboard;
  viewBillerTransactionGraphs: ViewBillerTransactionGraphs;
  billerTransactions: BillerTransactions;
  billerTransactionReport: BillerTransactionReport;
  recentTxsnMain: RecentTxsnMain;
  keyPerformanceOutput: KeyPerformanceOutput;
  inputBillerTxsnReport: InputBillerTxsnReport;
  transactionAmountOutput: TransactionAmountOutput;
  textHeading: string;
  loaderOff: number;
  activeAllFlag = false;
  activeYearFlag = false;
  activeMonthFlag = false;
  activeWeekFlag = false;
  activeTodayFlag = false;
  refreshFlag = false;

  isGetBillerTxsnUpdate = false;
  isGetDatewiswTxsnUpdate = false;
  isKeyPerIndiUpdate = false;
  isRecentTranUpdate = false;
  isBillerTxsnUpdate = false;
  subscription: Subscription;
  transactionNo = 0;
  transactionAmount = 0;
  lang: string;
  isRecentTransaction = false;   //for no data found

  customFlag = false;
  customFlagHide = false;

  from_Date: string;
  to_Date: string;
  finalToDate: Date;

  finalMinDate: Date;
  maxDate: Date;
  ture: any;


  constructor(private dataStorageService: DataStorageService,
    private billerService: BillerDashboardService,
    private logger: NGXLogger,
    private router: Router,
    private pipe: DatePipe,
    private leftMenu: LeftMenu,
    private dashboardService: DashboardService,
    // private loaderService: LoaderService
    private readonly translate: TranslateService
  ) { }

  ngOnInit() {
    this.subscription = this.dataStorageService.langData$.subscribe((data) => {
      //this.logger.debug('data lang is ' + data);
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem('lang');
      }
      this.translate.use(this.lang);
    });
    this.user = new User();
    this.user = JSON.parse(sessionStorage.getItem('sessuser'));
    window.scroll(0, 0);
    this.dataStorageService.setTabData('tabBillerDashboard');
    this.viewBillerDashboard = new ViewBillerDashboard();
    this.viewBillerTransactionGraphs = new ViewBillerTransactionGraphs();
    this.billerTransactions = new BillerTransactions();
    this.inputBillerTxsnReport = new InputBillerTxsnReport();
    this.billerTransactionReport = new BillerTransactionReport();
    this.transactionAmountOutput = new TransactionAmountOutput();
    this.recentTxsnMain = new RecentTxsnMain();
    this.keyPerformanceOutput = new KeyPerformanceOutput();

    this.viewBillerDashboard.mode = 'web';
    console.log(this.user);
    if (this.user){
      this.getTodayWeekMonthYearDate('today');
    }
    // this.getTodayWeekMonthYearDate('today');
    this.leftMenu = new LeftMenu();
    this.leftMenu.dashboard = true;
  }

  getTodayWeekMonthYearDate(valTime) {
    this.transactionNo = 0;
    this.transactionAmount = 0;
    //this.loaderService.show();
    this.refreshFlag = false;
    const todayFrmtdDate = this.pipe.transform(new Date(), 'yyyy-MM-dd');
    const first1 = new Date().getDate() - new Date().getDay();
    const last1 = first1 + 6;
    const ws = new Date(new Date().setDate(first1));
    const weekStartDate = this.pipe.transform(ws, 'yyyy-MM-dd');

    const wl = new Date(new Date().setDate(last1));
    const weekLastDate = this.pipe.transform(wl, 'yyyy-MM-dd');

    // -----------------------month and start n end date--------------

    const monStrt = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const monthStartDate = this.pipe.transform(monStrt, 'yyyy-MM-dd');

    const monEnd = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    const monthLastDate = this.pipe.transform(monEnd, 'yyyy-MM-dd');

    let yStrt = new Date(new Date().getFullYear(), 0, 1);
    let yearStartDate = this.pipe.transform(yStrt, 'yyyy-MM-dd');
    let yEnd = new Date(new Date().getFullYear(), 11, 31);
    let yearEndDate = this.pipe.transform(yEnd, 'yyyy-MM-dd');
    this.customFlag = false;
    if (valTime == 'all') {
      this.activeAllFlag = true;
      this.activeYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewBillerDashboard.datafor = 'all';
      this.viewBillerDashboard.startdate = yearStartDate;
      this.viewBillerDashboard.enddate = todayFrmtdDate;
      this.textHeading = 'All';

    }
    else if (valTime == 'year') {
      this.activeAllFlag = false;
      this.activeYearFlag = true;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewBillerDashboard.datafor = 'year';
      this.viewBillerDashboard.startdate = yearStartDate;
      this.viewBillerDashboard.enddate = yearEndDate;
      this.textHeading = 'This year\'s';

    }
    else if (valTime == 'month') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeMonthFlag = true;
      this.activeWeekFlag = false;
      this.activeTodayFlag = false;
      this.viewBillerDashboard.datafor = 'month';
      this.viewBillerDashboard.startdate = monthStartDate;
      this.viewBillerDashboard.enddate = monthLastDate;
      this.textHeading = 'This month\'s';

    }
    else if (valTime == 'week') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = true;
      this.activeTodayFlag = false;
      this.viewBillerDashboard.datafor = 'week';
      this.viewBillerDashboard.startdate = weekStartDate;
      this.viewBillerDashboard.enddate = weekLastDate;
      this.textHeading = 'This week\'s';
    }
    else if (valTime == 'today') {
      this.activeAllFlag = false;
      this.activeYearFlag = false;
      this.activeMonthFlag = false;
      this.activeWeekFlag = false;
      this.activeTodayFlag = true;
      this.viewBillerDashboard.datafor = 'today';
      this.viewBillerDashboard.startdate = todayFrmtdDate;
      this.textHeading = 'Today\'s';

    }

    this.billerId = this.user.user_type == 'Admin' ? 'all' : this.user.ekpay_id;
    // alert(this.billerId);

    this.customFlagHide = false;

    this.getBillerTransactionGraph();
    this.getBillerTxnsReportDataView();
    this.getBillerKeyPerformanceIndicator();
    this.getBillerRecentTransaction();

  }
  // -----------------------------Transactions Line Chart--------------------------------------------------
  public lineTransactionChartData: Array<any>;
  //  = [
  //   { data: [13, 12, 11, 5, 7, 12, 13, 53, 70, 100, 150], label: 'Transactions' },
  // ];
  public lineTransactionChartLabels: Array<any>;
  // = ['02 00:00', '02 01:00', '02 02:00', '02 03:00', '02 04:00', '02 05:00', '02 06:00', '02 07:00', '02 08:00', '02 09:00', '02 10:00'];
  public lineTransactionChartLegend = true;
  public lineTransactionChartType = 'bar';
  public lineTransactionChartOptions: any = {
    tooltips: {
      intersect: false,
      mode: 'index'
    },
    responsive: true,
    maintainAspectRatio: false,
    spanGaps: true,
    fill: false,
    scales:
      {
        xAxes: [{
          maxRotation: 90,
          ticks: {
            autoSkip: false,
          }
        }],
        yAxes:
          [
            {
              scaleLabel: {display: true, labelString: 'Number of Transactions', fontSize: 16, fontColor: transactionColor},
              position: 'left', id: '1', type: 'linear',
              ticks: this.dashboardService.customTicks
            },
            {
              scaleLabel: {display: true, labelString: 'Total Amount (in BDT)', fontSize: 16, fontColor: transactionAmountColor},
              position: 'right', id: '2', type: 'linear',
              ticks: this.dashboardService.customTicks
            }

          ]
      }
  };
  // to get dynamic data and labels of x-axis
  getTransaction(arrayOfNoOfTransaction: number[]) {
    this.transactionNo = 0;
    for (let i = 0; i < arrayOfNoOfTransaction.length; i++) {
      this.transactionNo += arrayOfNoOfTransaction[i];
    }

  }
  getBillerTransactionGraph() {
    this.isGetBillerTxsnUpdate = false;
    this.viewBillerTransactionGraphs.datafor = this.viewBillerDashboard.datafor;
    this.viewBillerTransactionGraphs.startdate = this.viewBillerDashboard.startdate;
    this.viewBillerTransactionGraphs.enddate = this.viewBillerDashboard.enddate;
    this.viewBillerTransactionGraphs.mode = this.viewBillerDashboard.mode;
    this.viewBillerTransactionGraphs.billerid = this.billerId;        //"b052"; //b009
    this.billerService.getBillerTxnsView(this.viewBillerTransactionGraphs).subscribe((data) => {
      this.isGetBillerTxsnUpdate = true;
      //this.logger.debug("Biller Transaction api call" + JSON.stringify(data.body));
      this.billerTransactions = data.body as BillerTransactions;
      this.getTransaction(this.billerTransactions.txns);
      this.getTransactionAmount(this.billerTransactions.amount);
      this.refreshFlag = true;
      this.lineTransactionChartData = [
        {
          data: this.billerTransactions.txns,
          label: 'No. of Transactions',
          yAxisID: '1',
          fill: true,
        },
        {
          data: this.billerTransactions.amount,
          label: 'Total Amount',
          yAxisID: '2',
          fill: true,
        }
      ];
      this.lineTransactionChartLabels = this.billerTransactions.timeperiod;
    });
  }
  public lineTrancationChartColors: Array<any> = [
    {
      backgroundColor: transactionColor,
      borderColor: transactionColor,
      pointBackgroundColor: transactionColor,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: transactionColor
    },
    {
      backgroundColor: transactionAmountColor,
      borderColor: transactionAmountColor,
      pointBackgroundColor: transactionAmountColor,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: transactionAmountColor
    }
  ];
  public lineTransactionAMtChartClicked(e: any): void {
    //console.log(e);
  }
  public lineTransactionChartHovered(e: any): void {
    //console.log(e);
  }
  // -----------------------Transaction Report----------------------------

  getBillerTxnsReportDataView() {
    this.isGetDatewiswTxsnUpdate = false;
    this.inputBillerTxsnReport.id = this.billerId;             //"b052";
    this.inputBillerTxsnReport.mode = this.viewBillerDashboard.mode;
    this.inputBillerTxsnReport.startdate = this.viewBillerDashboard.startdate;
    this.inputBillerTxsnReport.enddate = this.viewBillerDashboard.enddate;
    this.inputBillerTxsnReport.datafor = this.viewBillerDashboard.datafor;
    this.billerService.getBillerTxnsReportDataView(this.inputBillerTxsnReport).subscribe((data) => {
      this.isGetDatewiswTxsnUpdate = true;
      this.billerTransactionReport = data.body as BillerTransactionReport;
    });
  }
  // -------------------Recent Transactions--------------------------
  getBillerRecentTransaction() {
    this.isRecentTranUpdate = false;
    this.isRecentTransaction = false;
    this.inputBillerTxsnReport.id = this.billerId;          //"b052";
    this.inputBillerTxsnReport.mode = this.viewBillerDashboard.mode;
    this.inputBillerTxsnReport.startdate = this.viewBillerDashboard.startdate;
    this.inputBillerTxsnReport.enddate = this.viewBillerDashboard.enddate;
    this.inputBillerTxsnReport.datafor = this.viewBillerDashboard.datafor;
    this.billerService.getBillerRecentTransaction(this.inputBillerTxsnReport).subscribe((data) => {
      this.isRecentTranUpdate = true;
      this.recentTxsnMain = data.body as RecentTxsnMain;
      if (this.recentTxsnMain.recent_transactions == null) {
        this.isRecentTransaction = true;
      }
    });
  }
  // // -----------------------------Key Performance Indicator--------------------
  getBillerKeyPerformanceIndicator() {
    this.isKeyPerIndiUpdate = false;
    this.inputBillerTxsnReport.id =  this.billerId;         //"b052";
    this.inputBillerTxsnReport.mode = this.viewBillerDashboard.mode;
    this.inputBillerTxsnReport.startdate = this.viewBillerDashboard.startdate;
    this.inputBillerTxsnReport.enddate = this.viewBillerDashboard.enddate;
    this.inputBillerTxsnReport.datafor = this.viewBillerDashboard.datafor;
    this.billerService.getBillerKeyPerformanceIndicator(this.inputBillerTxsnReport).subscribe((data) => {
      this.isKeyPerIndiUpdate = true;
      this.keyPerformanceOutput = data.body as KeyPerformanceOutput;
    });
  }
  // -----------------------------Transaction Amount line chart 2--------------------------------------------------
  public lineTransactionAmtChartData: Array<any>;
  // = [{ data: [1100, 1250, 1425, 900, 1500], label: 'Transaction Amount' },];
  public lineTransactionAmtChartLabels: Array<any>;
  // = ['02 06:00', '02 07:00', '02 08:00', '02 09:00', '02 10:00'];
  public lineTransactionAmtChartLegend = true;
  public lineTransactionAmtChartType = 'bar';
  public lineTransactionAmtChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    spanGaps: true,
    fill: false,
    scales:
      {
        xAxes: [{
          maxRotation: 90,
          ticks: {
            autoSkip: false,
          }
        }],
        yAxes:
          [
            {
              backgroundColor: 'rgba(0,191,165,0.3)',
              scaleLabel: { display: true, labelString: 'Transaction Amount', fontSize: 16, fontColor: 'rgba(0,191,165,0.5)' },
              ticks: { min: 0, beginAtZero: true, fontSize: 13 }
            }
          ]
      }
  };
  getTransactionAmount(arrayOfTran: number[]) {
    this.transactionAmount = 0;
    for (let i = 0; i < arrayOfTran.length; i++) {
      this.transactionAmount += arrayOfTran[i];
    }
  }
  // getBillerTxnsAmountView() {
  //   this.isBillerTxsnUpdate = false;
  //   this.inputBillerTxsnReport.id = this.billerId;             //"b052";
  //   this.inputBillerTxsnReport.mode = this.viewBillerDashboard.mode;
  //   this.inputBillerTxsnReport.startdate = this.viewBillerDashboard.startdate;
  //   this.inputBillerTxsnReport.enddate = this.viewBillerDashboard.enddate;
  //   this.inputBillerTxsnReport.datafor = this.viewBillerDashboard.datafor;
  //   this.billerService.getBillerTxnsAmountView(this.inputBillerTxsnReport).subscribe((data) => {
  //     this.isBillerTxsnUpdate = true;
  //     //this.logger.debug("Biller Transaction api call" + JSON.stringify(data.body));
  //    // this.loaderOff = 1;
  //    // if (this.loaderOff == 1) {
  //       //this.isLoaderOff();
  //     //}
  //     this.transactionAmountOutput = data.body as TransactionAmountOutput;
  //     this.getTransactionAmount(this.transactionAmountOutput.total_amount);
  //     this.lineTransactionAmtChartData = [
  //       { data: this.transactionAmountOutput.total_amount, label: 'Transaction Amount' }
  //     ];
  //     this.lineTransactionAmtChartLabels = this.transactionAmountOutput.date_hour;
  //   });
  // }

  public lineTrancationAmtChartColors: Array<any> = [
    {
      backgroundColor: 'rgba(0,191,165,0.3)',
      borderColor: 'rgba(0,191,165,1)',
      pointBackgroundColor: 'rgba(0,191,165,1)',
      pointBorderColor: 'rgba(0,191,165,1)',
      pointHoverBackgroundColor: 'rgba(0,191,165,1)',
      pointHoverBorderColor: 'rgba(0,191,165,1)'
    },
  ];
  public lineTransactionAmtChartClicked(e: any): void {
    //console.log(e);
  }
  public lineTransactionAmtChartHovered(e: any): void {
    //console.log(e);
  }
  isLoaderOff() {
    // this.loaderService.hide();
  }

  getDashboardDataOfADateRange(objDate1, objDate2) {
    //console.log("range data fatch");
    //this.logger.debug("custom dashboard...");
    const mm1 = new Date(objDate1).getMonth() + 1;
    const mm2 = new Date(objDate2).getMonth() + 1;
    const rStartDate = new Date(objDate1).getFullYear() + '-' + mm1 + '-' + new Date(objDate1).getDate();
    //console.log(rStartDate);
    const rangeStartDate = this.pipe.transform(rStartDate, 'yyyy-MM-dd');
    const rLastDate = new Date(objDate2).getFullYear() + '-' + mm2 + '-' + new Date(objDate2).getDate();
    const rangeLastDate = this.pipe.transform(rLastDate, 'yyyy-MM-dd');

    this.viewBillerDashboard.datafor = 'custom';
    this.viewBillerDashboard.startdate = rangeStartDate;
    this.viewBillerDashboard.enddate = rangeLastDate;
    this.textHeading = 'Custom\'s ';

    this.customFlagHide = false;

    this.getBillerTransactionGraph();
    this.getBillerTxnsReportDataView();
    this.getBillerRecentTransaction();
    this.getBillerKeyPerformanceIndicator();
  }

  onCustom(){
    this.customFlagHide = true;
    this.customFlag = true;
    this.activeAllFlag = false;
    this.activeYearFlag = false;
    this.activeMonthFlag = false;
    this.activeWeekFlag = false;
    this.activeTodayFlag = false;
  }

  limitOfTo() {
    let m;
    let d;
    let y;
    let nM;
    let nD;
    let nY;
    let maxDateForTo;
    m = new Date(this.from_Date).getMonth() + 1;
    d = new Date(this.from_Date).getDate();
    y = new Date(this.from_Date).getFullYear();
    if ((m == 1 || m == 3 || m == 8) && d == 31) {
      nM = m + 3;
      nD = 30;
      nY = y;
      maxDateForTo = nY + '-' + nM + '-' + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if ((m == 1 || m == 3 || m == 8) && d != 31) {
      nM = m + 3;
      nD = d;
      nY = y;
      maxDateForTo = nY + '-' + nM + '-' + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if (m == 2 || m == 4 || m == 9 || m == 5 || m == 6 || m == 7) {
      nM = m + 3;
      nD = d;
      nY = y;
      maxDateForTo = nY + '-' + nM + '-' + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if (m == 10) {
      nM = 1;
      nD = d;
      const year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + '-' + nM + '-' + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 11 && (d == 30 || d == 29)) {
      nM = 2;
      // nD = 28;
      const year = y + 1;
      let isLeap = false;

      if (year % 4 == 0) {
        if (year % 100 == 0) {
          if (year % 400 == 0)
            isLeap = true;
          else
            isLeap = false;
        }
        else
          isLeap = true;
      }
      else {
        isLeap = false;
      }

      if (isLeap == true) {
        nD = 29;
      }
      else {
        nD = 28;
      }
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + '-' + nM + '-' + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 11 && !(d == 30 || d == 29)) {
      nM = 2;
      nD = d;
      const year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + '-' + nM + '-' + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 12) {
      nM = 3;
      nD = d;
      const year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + '-' + nM + '-' + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboards/biller-dashboard/biller-dashboard.component.ts